module.exports = __webpack_public_path__ + "static/img/chart.4d6b2a28.svg";